import { Component, Input } from "@angular/core";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-report-pdf-footer",
    imports: [SharedMaterialModule, SharedDsnModule],
    styles: [
        `
            .container-simple {
                background-color: var(--background-color-petroleum);
                height: 64px;
                width: 100%;
            }
            .container-full {
                width: 100%;
                height: 94px;
            }
        `
    ],
    template: `
        @if (type === "simple") {
            <div
                fxLayout="row"
                fxLayoutAlign="center center"
                class="container-simple gap-24"
                fxFlex
            >
                <p class="text-10-semi-bold color-text-white-primary">
                    Acesse esse Dash na versão digital para explorar todos os
                    recursos.
                </p>
                <a
                    [href]="linkDigital"
                    target="_blank"
                    style="text-decoration: none;"
                >
                    <dsn-button
                        [label]="'Abrir Dash digital'"
                        [type]="'primary'"
                        [size]="'small'"
                    ></dsn-button>
                </a>
            </div>
        } @else {
            <a [href]="linkDigital" target="_blank">
                <div
                    class="container-full"
                    [style.background-image]="'url(/images/footer-pdf.png)'"
                    [style.background-size]="'cover'"
                    [style.background-position]="'center'"
                ></div>
            </a>
        }
    `
})
export class ReportPdfFooterComponent {
    @Input({ required: true }) linkDigital: string = "";
    @Input({ required: false }) type: "simple" | "full" = "simple";
}
